import { render, staticRenderFns } from "./SubGroup.vue?vue&type=template&id=7f0a4373&scoped=true"
import script from "./SubGroup.vue?vue&type=script&lang=js"
export * from "./SubGroup.vue?vue&type=script&lang=js"
import style0 from "./SubGroup.vue?vue&type=style&index=0&id=7f0a4373&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0a4373",
  null
  
)

export default component.exports